import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-number',
  templateUrl: './contact-number.component.html',
  styleUrls: ['./contact-number.component.less']
})
export class ContactNumberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
